import React, { useContext, useEffect, useRef } from "react";
import styles from "./styles/EditNotaryPopup.module.css";
import { useState } from "react";
import PhoneInput from "react-phone-input-2";
import fr_phone_countries from "react-phone-input-2/lang/fr.json";

import parse from "html-react-parser";
import { LanguageContext } from "../../Context/changeLanguageProvider";
import useWindowDimensions from "../Footer/footer";

function NotaryBenefPopup({ toEdit, onClose }) {
  const [showTopShadow, setShowTopShadow] = useState(false);
  const { width } = useWindowDimensions();
  const [showBottomShadow, setShowBottomShadow] = useState(false);
  const divElementRef = useRef(null);
  const websiteCurrentLang = useContext(LanguageContext).language;
  const [content, setContent] = useState(
    websiteCurrentLang.content.User.AddNotaryPopup.AddNotaryPopup
  );
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    setContent(websiteCurrentLang.content.User.AddNotaryPopup.AddNotaryPopup);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);

  useEffect(() => {
    const divElement = divElementRef.current;

    const handleScroll = () => {
      const scrollTop = divElement.scrollTop;
      const scrollHeight = divElement.scrollHeight;
      const clientHeight = divElement.clientHeight;
      setShowTopShadow(scrollTop > 0);
      setShowBottomShadow(scrollTop + clientHeight < scrollHeight - 10);
    };

    // Call handleScroll once on initial load to set shadows
    handleScroll();

    divElement.addEventListener("scroll", handleScroll);

    return () => {
      divElement.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // There needs to be a trusted advisor and a notary with the same data. This means that if there is a
  // trustee having the same phone number, email and  name as the notary, we need to grab that one

  const [notary, setNotary] = useState({
    user_id: toEdit?.user_id,
    name: toEdit?.name,
    email: toEdit?.email,
    phone_number: toEdit?.phone_number,
    address: toEdit?.address,
    additional_information: toEdit?.additional_information,
    notify: toEdit?.notify,
    type: toEdit?.type,
  });

  // textarea
  const maxMessageLength = 10000; // Define the maximum character length for the message field

  useEffect(() => {
    document.documentElement.style.overflow = "hidden";
    return () => {
      document.documentElement.style.overflow = "unset";
    };
  }, []);

  return (
    <div className={styles.background}>
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        style={
          width <= 599
            ? {
                height: window.innerHeight - 10,
              }
            : {}
        }
        className={styles.main_box}
      >
        <div onClick={onClose} className={styles.close_logo}></div>
        <div className={styles.title}>
          {dublicatedcontent.view} {notary.name} {dublicatedcontent.details}
        </div>
        <div
          className={styles.popup_scrollable}
          id="scrollContainer"
          ref={divElementRef}
        >
          <div
            className={`${styles.shadow_top} ${
              showTopShadow ? styles.active : ""
            }`}
          />
          {/* <InfoTitle message={"Lorem ipsum text ..."} title={content.addNotaryPopupText1} /> */}
          <div
            className={styles.large_text}
            style={{
              maxWidth: "100%",
            }}
          >
            {parse(content.addNotaryPopupText2)}
          </div>

          <div className={styles.center}>
            <div className={styles.field_wrap}>
              <div className={styles.field}>
                <div className={`${styles.input_title} `}>
                  {content.addNotaryPopupText3}
                </div>
                <input
                  disabled={true}
                  value={notary.type}
                  className={`legalInput ${styles.beneficiary_input}}`}
                  placeholder={content.addNotaryPopupText8}
                />
              </div>
            </div>

            <div className={styles.field_wrap}>
              <div className={styles.field}>
                <div className={`${styles.input_title} `}>
                  {content.addNotaryPopupText7}
                </div>
                <input
                  disabled={true}
                  value={notary.name}
                  className={`legalInput ${styles.beneficiary_input}}`}
                  placeholder={content.addNotaryPopupText8}
                ></input>
              </div>

              <div className={styles.field}>
                <div className={`${styles.input_title} `}>
                  {content.addNotaryPopupText9}
                </div>
                <div className={`legalInput ${styles.phone_div}}`}>
                  <PhoneInput
                    inputClass="legalInput"
                    disabled={true}
                    countryCodeEditable={false}
                    localization={
                      websiteCurrentLang?.label === "fr"
                        ? fr_phone_countries
                        : undefined
                    }
                    country={websiteCurrentLang?.label === "fr" ? "fr" : "us"}
                    placeholder={content.addNotaryPopupText10}
                    value={notary.phone_number}
                  />
                </div>
              </div>
            </div>

            <div className={styles.field_wrap}>
              <div className={styles.field}>
                <div className={`${styles.input_title} `}>
                  {content.addNotaryPopupText11}
                </div>
                <input
                  disabled={true}
                  value={notary.email}
                  className={`legalInput ${styles.beneficiary_input}`}
                  placeholder={dublicatedcontent?.dublicatedText74}
                ></input>
              </div>

              <div className={styles.field}>
                <div className={styles.input_title}>
                  {content.addNotaryPopupText13}
                </div>
                <input
                  disabled={true}
                  value={notary.address}
                  className={`legalInput ${styles.beneficiary_input}`}
                  placeholder={content?.addNotaryPopupText15}
                ></input>
              </div>
            </div>

            <div className={styles.message_field}>
              <div className={styles.input_title}>
                {content.addNotaryPopupText16}
              </div>
              <textarea
                style={{
                  height: "max-content !important",
                }}
                disabled={true}
                maxLength={maxMessageLength}
                id="textarea"
                value={notary?.additional_information}
                placeholder={content.addNotaryPopupText16}
                className={`legalInput ${styles.large_message}`}
              ></textarea>
              <div
                className={`${styles.file_counter} ${
                  notary.additional_information?.length === maxMessageLength
                    ? styles.error_text
                    : ""
                }`}
              >
                {notary.additional_information?.length === maxMessageLength ? (
                  <>{content.addNotaryPopupText17}</>
                ) : (
                  ""
                )}
                {notary.additional_information?.length}/{maxMessageLength}{" "}
                {content.addNotaryPopupText21}
              </div>
            </div>
          </div>

          <div
            className={`${styles.shadow_bottom} ${
              showBottomShadow ? styles.active : ""
            }`}
          />
        </div>

        <div className={styles.actions_toolbar}>
          <button onClick={() => onClose()} className={styles.cancel_button}>
            {dublicatedcontent.dublicatedText76}
          </button>
        </div>
      </div>
    </div>
  );
}

export default NotaryBenefPopup;
